/**
 * 复盘台战报预览与导出（Markdown 渲染为 <pre>，附复制 / 下载按钮）。
 */
import { Button, Panel } from '../ui/primitives.tsx';

export function ReviewReportPreview({
  markdown,
  status,
  copied,
  exporting,
  onExport,
  onCopy,
  onDownload,
}: {
  markdown: string;
  status: string;
  copied: boolean;
  exporting: boolean;
  onExport: () => void;
  onCopy: () => void;
  onDownload: () => void;
}) {
  return (
    <Panel
      title="《纵横杯跟场诊断战报》"
      subtitle="Markdown 预览 · 可复制 / 下载为 .md · 数据口径见文末声明"
      testId="review-report-panel"
      actions={
        <div className="flex flex-wrap items-center gap-2">
          <Button size="sm" variant="primary" testId="review-export" onClick={onExport} disabled={exporting}>
            {exporting ? '导出中…' : '导出战报'}
          </Button>
          <Button size="sm" variant="secondary" testId="review-copy" onClick={onCopy}>
            {copied ? '已复制' : '复制 Markdown'}
          </Button>
          <Button size="sm" variant="secondary" testId="review-download" onClick={onDownload}>
            下载 .md
          </Button>
        </div>
      }
    >
      <p className="mb-2 text-xs text-slate-400" data-testid="review-export-status">
        {status || '可直接导出战报，或复制 Markdown 粘贴到复盘文档。'}
      </p>
      <pre
        data-testid="review-report-preview"
        className="mono max-h-[520px] overflow-auto whitespace-pre-wrap rounded-lg border border-white/10 bg-black/30 p-3 text-[11px] leading-relaxed text-slate-300"
      >
        {markdown}
      </pre>
    </Panel>
  );
}
